// Per-model light rigs. Angles are degrees: az 0 = front (towards the default camera), 90 = right; el 90 = straight above.
export const LIGHT_TYPES = [
  ['directional', 'SUN'], ['point', 'BULB'], ['spot', 'SPOT'], ['ambient', 'AMBIENT'], ['hemisphere', 'SKY']
];
export const AIMED = new Set(['directional', 'point', 'spot']);
export const MAX_LIGHTS = 12;

const uid = () => Math.random().toString(36).slice(2, 10);

export const newLight = (type = 'directional') => ({
  id: uid(), type, on: true, color: '#ffffff', ground: '#3a2a1c',
  intensity: type === 'ambient' || type === 'hemisphere' ? 0.6 : 1.5,
  az: 45, el: 35, dist: 2, angle: 30, penumbra: 0.3
});

const L = (type, color, intensity, az = 0, el = 30, extra = {}) => ({ ...newLight(type), color, intensity, az, el, ...extra });

const PRESETS = {
  warm: ['#ffd9a8', '#3a2010', 1.0, '#ffcf8a', '#e07a30', '#ffe0b0'],
  balanced: ['#fff6ea', '#3a2a1c', 1.1, '#fff1dc', '#ffc98a', '#ffffff'],
  neutral: ['#ffffff', '#2a2a2a', 1.1, '#ffffff', '#e8ecf2', '#ffffff']
};

export function presetRig(name) {
  const [sky, ground, hemi, key, rim, front] = PRESETS[name] || PRESETS.balanced;
  return [
    L('hemisphere', sky, hemi, 0, 90, { ground }),
    L('directional', key, 1.6, 51, 43),
    L('directional', rim, 0.45, -127, 22),
    L('directional', front, 0.5, 0, 17)
  ];
}

export const rigFor = (item) => (Array.isArray(item?.lights) ? item.lights : presetRig(item?.lighting));

export function lightPosition(az, el, r) {
  const a = (az * Math.PI) / 180;
  const e = (el * Math.PI) / 180;
  return [Math.sin(a) * Math.cos(e) * r, Math.sin(e) * r, Math.cos(a) * Math.cos(e) * r];
}
